{
  "nav": {
    "features": "বৈশিষ্ট্য",
    "formats": "ফরম্যাট",
    "screenshots": "স্ক্রিনশট",
    "download": "ডাউনলোড",
    "openSource": "ওপেন সোর্স",
    "github": "GitHub"
  },
  "hero": {
    "title": "SaiPair",
    "subtitle": "বিনামূল্যে টুর্নামেন্ট ব্যবস্থাপনা সফটওয়্যার",
    "description": "ওপেন-সোর্স, অফলাইন ডেস্কটপ অ্যাপ। সুইস, রাউন্ড রবিন, এলিমিনেশন এবং আরও।",
    "download": "এখনই ডাউনলোড করুন",
    "viewOnGithub": "GitHub-এ দেখুন"
  },
  "features": {
    "title": "বৈশিষ্ট্য",
    "subtitle": "টুর্নামেন্ট পরিচালনার জন্য সবকিছু",
    "f1_title": "একাধিক ফরম্যাট",
    "f1_desc": "সুইস, রাউন্ড রবিন, ডাবল রাউন্ড রবিন, সিঙ্গেল ও ডাবল এলিমিনেশন।",
    "f2_title": "অটো পেয়ারিং",
    "f2_desc": "স্মার্ট ইঞ্জিন তাৎক্ষণিক পেয়ারিং তৈরি করে।",
    "f3_title": "লাইভ র‍্যাঙ্কিং",
    "f3_desc": "কনফিগারযোগ্য টাইব্রেক নিয়মে রিয়েল-টাইম র‍্যাঙ্কিং।",
    "f4_title": "অফলাইন ফার্স্ট",
    "f4_desc": "ইন্টারনেট দরকার নেই। সমস্ত ডেটা লোকালে সংরক্ষিত।",
    "f5_title": "ইম্পোর্ট ও এক্সপোর্ট",
    "f5_desc": "Excel/CSV থেকে খেলোয়াড় ইম্পোর্ট করুন। র‍্যাঙ্কিং ও পেয়ারিং এক্সপোর্ট করুন।",
    "f6_title": "প্রিন্ট রেডি",
    "f6_desc": "তালিকা, পেয়ারিং, র‍্যাঙ্কিং এবং আরও প্রিন্ট করুন।",
    "f7_title": "বহু ভাষা",
    "f7_desc": "১০টি ভাষায় উপলব্ধ।",
    "f8_title": "বিনামূল্যে ও ওপেন সোর্স",
    "f8_desc": "MIT লাইসেন্স, চিরকাল বিনামূল্যে।"
  },
  "formats": {
    "title": "টুর্নামেন্ট ফরম্যাট",
    "subtitle": "সঠিক ফরম্যাট নির্বাচন করুন",
    "swiss_title": "সুইস সিস্টেম",
    "swiss_desc": "প্রতিটি রাউন্ডে একই রকম স্কোরের খেলোয়াড়দের জোড়া করে।",
    "roundRobin_title": "রাউন্ড রবিন",
    "roundRobin_desc": "প্রত্যেকে প্রত্যেকের সাথে খেলে।",
    "elimination_title": "সিঙ্গেল এলিমিনেশন",
    "elimination_desc": "প্রতিটি রাউন্ডে পরাজিত বাদ।",
    "doubleElim_title": "ডাবল এলিমিনেশন",
    "doubleElim_desc": "খেলোয়াড়রা দ্বিতীয় সুযোগ পায়।"
  },
  "screenshots": {
    "title": "স্ক্রিনশট",
    "subtitle": "SaiPair কার্যরত দেখুন",
    "placeholder": "স্ক্রিনশট শীঘ্রই আসছে — ডাউনলোড করে চেষ্টা করুন!"
  },
  "download": {
    "title": "ডাউনলোড",
    "subtitle": "Windows, macOS এবং Linux-এ উপলব্ধ",
    "windows": "Windows",
    "macos": "macOS",
    "linux": "Linux",
    "getLatest": "সর্বশেষ সংস্করণ ডাউনলোড",
    "allReleases": "সব রিলিজ দেখুন"
  },
  "openSource": {
    "title": "ওপেন সোর্স",
    "subtitle": "উন্মুক্তভাবে নির্মিত, MIT লাইসেন্স",
    "description": "SaiPair বিনামূল্যে ও ওপেন-সোর্স সফটওয়্যার। সবাইকে স্বাগতম।",
    "github": "GitHub রিপোজিটরি",
    "issues": "সমস্যা রিপোর্ট করুন",
    "discussions": "আলোচনায় যোগ দিন"
  },
  "footer": {
    "copyright": "© {{year}} SaiPair. MIT লাইসেন্স।",
    "madeWith": "বিশ্বজুড়ে টুর্নামেন্ট আয়োজকদের জন্য ❤ দিয়ে তৈরি।"
  },
  "language": {
    "en": "English",
    "zh-CN": "中文",
    "es": "Español",
    "fr": "Français",
    "pt": "Português",
    "ru": "Русский",
    "ja": "日本語",
    "ar": "العربية",
    "hi": "हिन्दी",
    "bn": "বাংলা"
  }
}
